/* eslint-disable no-mixed-operators */
import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class WallGuide {
  public spt: SVGSprite;

  viewObj: SVGElement;

  lineObj: SVGElement;

  textObj: SVGElement;

  textboxObj: SVGElement;

  refElem1: Element;

  refElem2: Element;

  transformMatrix: string;

  text: string;

  index: number;

  parentObj: marietta.webcad.item.MonicaObject;

  _firstDot: marietta.core.Point;

  get firstDot() { return this._firstDot; }

  set firstDot(_dot: marietta.core.Point) {
    this._firstDot = _dot;
    this.updateTransforms();
  }

  _secondDot: marietta.core.Point;

  get secondDot() { return this._secondDot; }

  set secondDot(_dot: marietta.core.Point) {
    this._secondDot = _dot;
    this.updateTransforms();
  }

  fontSize: number;

  textboxObjWidth: number;

  textboxObjHeight: number;

  textboxWidth: number;

  textboxHeight: number;

  textboxPadding: number;

  private readonly MAX_BOX_HEIGHT: number;

  private readonly MAX_FONT_SIZE: number;

  constructor(targetNode: Element, id: number, color = { line: '#2d2d2e', text: '#000000' }) {
    this.textboxObjWidth = 40;
    this.textboxObjHeight = 18;
    this.textboxWidth = 55;
    this.textboxHeight = 14;
    this.fontSize = 10;
    this.MAX_BOX_HEIGHT = 9;
    this.MAX_FONT_SIZE = 7;
    this.textboxPadding = 8;
    this.index = id;

    this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.viewObj.id = `wallGuide_${id}`;

    // ラインの作成
    this.lineObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineObj.setAttribute('stroke', color.line);
    this.lineObj.setAttribute('stroke-width', '1');
    this.lineObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    this.lineObj.setAttribute('id', 'guide_line');
    this.viewObj.appendChild(this.lineObj);
    this.refElem1 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.refElem2 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1.setAttribute('stroke', color.line);
    line1.setAttribute('stroke-width', '1');
    const line2 = line1.cloneNode();
    this.refElem1.appendChild(line1);
    this.refElem1.appendChild(line2);

    const line3 = line1.cloneNode();
    const line4 = line1.cloneNode();

    this.refElem2.appendChild(line3);
    this.refElem2.appendChild(line4);

    this.viewObj.append(this.refElem1);
    this.viewObj.append(this.refElem2);
    this.textObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    this.textObj.setAttribute('id', 'guideText');
    this.textObj.setAttribute('fill', color.text);
    this.textObj.style.fontSize = `${(10).toString()}px`;
    this.textObj.textContent = this.text;
    this.textObj.setAttribute('class', 'wallGuideText');
    this.viewObj.appendChild(this.textObj);

    this.spt = new SVGSprite(this.viewObj);

    targetNode.appendChild(this.viewObj);
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    if (this.firstDot === undefined || this.secondDot === undefined) return;
    this.textObj.style.fontSize = `${(10).toString()}px`;
    this.lineObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
    this.text = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(this.firstDot, this.secondDot))).toString();
    const textPost = this.getTextPosition();
    this.textObj.setAttribute('x', String(textPost.textX));
    this.textObj.setAttribute('y', String(textPost.textY));

    const l1 = this.getPerpendicularLine(this.firstDot, this.secondDot);
    this.refElem1.children[0].setAttribute('x1', String(l1.p1.x));
    this.refElem1.children[0].setAttribute('y1', String(l1.p1.y));
    this.refElem1.children[0].setAttribute('x2', String(l1.p2.x));
    this.refElem1.children[0].setAttribute('y2', String(l1.p2.y));

    const l2 = marietta.webcad.util.WebCADUtil.rotateLine(l1.p1, l1.p2, 45);
    this.refElem1.children[1].setAttribute('x1', String(l2.start.x));
    this.refElem1.children[1].setAttribute('y1', String(l2.start.y));
    this.refElem1.children[1].setAttribute('x2', String(l2.end.x));
    this.refElem1.children[1].setAttribute('y2', String(l2.end.y));

    const l3 = this.getPerpendicularLine(this.secondDot, this.firstDot);
    this.refElem2.children[0].setAttribute('x1', String(l3.p1.x));
    this.refElem2.children[0].setAttribute('y1', String(l3.p1.y));
    this.refElem2.children[0].setAttribute('x2', String(l3.p2.x));
    this.refElem2.children[0].setAttribute('y2', String(l3.p2.y));

    const l4 = marietta.webcad.util.WebCADUtil.rotateLine(l3.p1, l3.p2, 45);
    this.refElem2.children[1].setAttribute('x1', String(l4.start.x));
    this.refElem2.children[1].setAttribute('y1', String(l4.start.y));
    this.refElem2.children[1].setAttribute('x2', String(l4.end.x));
    this.refElem2.children[1].setAttribute('y2', String(l4.end.y));
  }

  /**
   * テキストの中心位置を計算する関数
   * @returns object
   */
  getTextPosition() {
    const cp = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
    this.textObj.textContent = this.text;
    const svg = document.getElementById('textDummyContainerSvg');
    const cloneObj: SVGElement = (<SVGElement> this.textObj.cloneNode(true));
    svg.appendChild(cloneObj);
    const bound = cloneObj.getBoundingClientRect();
    cloneObj.remove();
    const { width } = bound;
    const { height } = bound;

    const textX = cp.x - width / 2;
    const textY = cp.y + height / 2;
    return { textX, textY };
  }

  /**
   * textBoxの中心位置を計算する関数
   * @returns object
   */
  getTextBoxPosition() {
    const cp = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
    const bound = this.textboxObj.getBoundingClientRect();

    const { width } = bound;
    const { height } = bound;
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    const textX = cp.x - width * sc / 2;
    const textY = cp.y - height * sc / 2;
    return { textX, textY };
  }

  getPerpendicularLine = (start: marietta.core.Point, end: marietta.core.Point) => {
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    const lp1 = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistanceFromLine(start, end, 90, 5 * (1 / scale));
    const lp2 = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistanceFromLine(start, end, -90, 5 * (1 / scale));
    return { p1: lp1, p2: lp2 };
  }

  /**
   * 表示ON
   */
  show() {
    this.spt.element.style.visibility = 'visible';
  }

  /**
   * 表示ON
   */
  hide() {
    this.spt.element.style.visibility = 'hidden';
  }

  /**
   * 壁の編集テキストボックスを表示
   */
  showWallInput() {
    // シェアモードでは寸法を入力させない（入力による移動・変形を防ぐ）
    if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return;
    this.hideTextObj();
    this.createTextBoxObj();
  }

  /**
   * ガイドテキストを表示
   */
  showTextObj() {
    this.textObj.style.display = 'block';
  }

  /**
   * テキストボックスを表示
   */
  createTextBoxObj() {
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    /** 倍率 */
    const magnification = 1 / scale;
    const paddingWidth = this.textboxPadding * scale;
    let fontSize = Math.floor(this.fontSize * magnification);
    let textboxWidth = Math.floor(this.textboxWidth * magnification);
    let textboxHeight = Math.floor(this.textboxHeight * magnification);
    if (fontSize < this.MAX_FONT_SIZE) {
      fontSize = this.MAX_FONT_SIZE;
    }
    if (textboxWidth < this.textboxWidth) {
      textboxWidth = this.textboxWidth;
    }
    if (textboxHeight < this.MAX_BOX_HEIGHT) {
      textboxHeight = this.MAX_BOX_HEIGHT;
    }

    this.textboxObj = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    this.textboxObj.setAttribute('height', (this.textboxObjHeight * magnification + (this.textboxPadding * scale)).toString());
    this.textboxObj.setAttribute('width', (textboxWidth + paddingWidth * 2).toString());
    const inpT = document.createElement('input');
    inpT.setAttribute('type', 'text');
    inpT.setAttribute('maxlength', '5');
    inpT.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    inpT.setAttribute('style', `font-size:${fontSize}px;width:${textboxWidth}px;height:${textboxHeight}px;`);
    // ロック中のアイテムは寸法を編集させない
    inpT.disabled = this.parentObj?.itemInfo?.lock === true;
    this.textboxObj.appendChild(inpT);
    this.textboxObj.setAttribute('id', 'wallGuideTextbox');
    this.textboxObj.setAttribute('class', 'wallGuideTextbox');
    inpT.style.lineHeight = `${textboxHeight}px`;
    const wallObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    wallObj.setAttribute('class', 'dummy_wall_input');
    if (marietta.webcad.WebCADGlobal.itemManager.itemController != null && (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoomMansion || marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerWallObject  || marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoomDetached)) {
      wallObj.appendChild(this.textboxObj);
      marietta.webcad.WebCADGlobal.itemManager.itemController.spt.addChild(new SVGSprite(wallObj));
    }
    // this.viewObj.appendChild(this.textboxObj);
    if (marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      // inpL.setAttribute("style", "position: fixed !important;");
      inpT.addEventListener('touchstart', this.onInputTextboxMouseDownMe, { passive: false });
    } else {
      inpT.addEventListener('mousedown', this.onInputTextboxMouseDownMe);
    }
    inpT.addEventListener('keyup', (event:KeyboardEvent)=>{
      //距離変更
      this.changeDistance(event);

      //見積更新（エンターキーならば）
      if (event.key === 'Enter') {
        marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
      }
    });
    if (this.firstDot === undefined || this.secondDot === undefined) return;
    const textPost = this.getTextBoxPosition();
    const textboxTransform = `matrix(1,0,0,1,${String(textPost.textX)},${String(textPost.textY)})`;
    this.textboxObj.setAttribute('transform', textboxTransform);
    (<HTMLInputElement> this.textboxObj.children[0]).value = this.text;
    this.textboxObj.style.display = 'block';
  }

  /**
   * ガイドテキストを隠す
   */
  hideTextObj() {
    this.textObj.style.display = 'none';
  }

  /**
   * テキストボックスを隠す
   */
  removeTextBoxObj() {
    if (this.textboxObj !== undefined) {
      const inputText = this.textboxObj.querySelector('input');
      if (marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        inputText.removeEventListener('touchstart', this.onInputTextboxMouseDownMe);
      } else {
        inputText.removeEventListener('mousedown', this.onInputTextboxMouseDownMe);
      }
      this.textboxObj.remove();
      this.showTextObj();
    }
  }

  /**
   * テキスト オブジェクトがクリックされました
   */
  onMouseDownMe = () => {
    if (document.querySelector('.wallGuideTextbox')) {
      document.querySelectorAll('.wallGuideTextbox').forEach((element) => {
        element.remove();
      });
    }
    if (document.querySelector('.wallGuideText')) {
      document.querySelectorAll('.wallGuideText').forEach((element: SVGElement) => {
        // eslint-disable-next-line no-param-reassign
        element.style.display = 'block';
      });
    }
    this.showWallInput();
  }

  /**
   * テキストボックスがクリックされました
   */
  onInputTextboxMouseDownMe = (e: MouseEvent) => {
    if (marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      (<HTMLInputElement>e.currentTarget).focus();
      e.stopImmediatePropagation();
      e.stopPropagation();
    } else {
      e.stopPropagation();
    }
  }

  /**
   * 距離テキストボックスキーボードイベントトリガーの変更
   * @param event
   */
  changeDistance = (event: KeyboardEvent) => {
    function validate(e: any) {
      const t = e.value;
      const ex = /^[0-9]+\.?[0-9]*$/;
      if (ex.test(t) === false) {
        e.value = t.substring(0, t.length - 1);
      } else {
        e.value = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t;
        const x = parseFloat(t);
        if (Number.isNaN(x) || x < 0 || x > 100000) {
          e.value = t.substring(0, t.length - 1);
        }
      }
    }
    validate(event.currentTarget);
    const target = <HTMLInputElement>event.currentTarget;
    if (target.value === '') {
      target.style.border = 'solid 2px red';
    } else if (Number.isNaN(target.value) || parseFloat((event.currentTarget as HTMLInputElement).value) < 0 || parseFloat((event.currentTarget as HTMLInputElement).value) > 100000) {
      target.style.border = 'solid 2px red';
    } else {
      target.style.border = 'solid 2px green';
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (target.value === '' || Number.isNaN(target.value) || parseFloat((event.currentTarget as HTMLInputElement).value) < 0 || parseFloat((event.currentTarget as HTMLInputElement).value) > 100000) {
        target.style.border = 'solid 2px red';
      } else {
        const newDistance: number = parseFloat((event.currentTarget as HTMLInputElement).value);
        this.parentObj.updateItemWithInput(newDistance, this.index);
        target.style.border = 'solid 2px green';
      }
    }

    event.stopPropagation();
  }
}
